import React, {useState, useEffect, useRef} from 'react'
import Header from 'components/Headers/Header';
import {
    Card,
    CardBody,
    CardTitle,
    CardSubtitle,
    CardHeader,
    Container,
    CardText,
    Button,
    Row,
    Col,
    Badge,
    CardImg,
    CardImgOverlay,
    TabContent, TabPane, Nav, NavItem, NavLink, 
    FormGroup,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Input,
    ListGroup,
    ListGroupItem,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Label,
    Form
} from "reactstrap";
import AddTpcCourseModal from 'components/Modal/AddTpcCourseModal';
import Paginate from 'components/Pagination/TpcCoursesPagination';
import { fetchPaymentRecord } from 'redux/Payments/PaymentsActions';
import { getCollectionNameForSpecialty } from 'util/specialtyCollections';
import ManageCourseItem from 'components/Courses/ManageCourseItem';
import { connect, useDispatch } from 'react-redux';
import { fetchTpcCourses, deleteTpcCourse, deleteTpcCourseReset, saveCoursesOrder, saveCoursesOrderReset} from 'redux/ManageTpcCourses/ManageTpcCoursesActions'
import Swal from 'sweetalert2'
import ManageTpcCoursesLessons from './ManageTpcCoursesLessons';

import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';


// DnD Item Types
const ItemType = {
    COURSE: "COURSE",
};
  
const DraggableCourse = ({ course, index, moveCourse }) => {
    const ref = useRef(null);

    const [{ isDragging }, drag] = useDrag({
        type: ItemType.COURSE,
        item: { index },
        collect: (monitor) => ({
        isDragging: monitor.isDragging(),
        }),
    });

    const [, drop] = useDrop({
        accept: ItemType.COURSE,
        hover: (draggedItem) => {
            if (draggedItem.index !== index) {
                moveCourse(draggedItem.index, index);
                draggedItem.index = index;
            }
        },
    });

    drag(drop(ref));

    return (
        <div
            ref={ref}
            style={{
                padding: "15px",
                border: "1px solid #ccc",
                marginBottom: "10px", // Add margin to prevent overlap
                borderRadius: "5px",
                backgroundColor: isDragging ? "#e0e0e0" : "#f9f9f9",
                cursor: "grab",
            }}

            className='w-100'
            >
            <strong>Order {index + 1} : </strong> <span>{course.courseTitle}</span>
        </div>

    );
};

const ManageTpcCourses = (props) => {
    const dispatch = useDispatch()
    const activeSpecialty = props.activeSpecialty;

    useEffect(() => {
        dispatch(fetchPaymentRecord({table: getCollectionNameForSpecialty('tpcCourses', activeSpecialty)}))

    }, [activeSpecialty]);
    

    const [currentPage, setCurrentPage] = useState(1);
	const [coursesPerPage] = useState(6);

    const [modalAddTpcCourseModal, setModalAddTpcCourseModal] = useState(false);
    const [tpcCoursesLists, setTpcCoursesLists] = useState([]);


    const indexOfLastPost = currentPage * coursesPerPage;
	const indexOfFirstPost = indexOfLastPost - coursesPerPage;
	const currentCourses = tpcCoursesLists.slice(indexOfFirstPost, indexOfLastPost);

	const paginate = (pageNumber) => {
		setCurrentPage(pageNumber);
	};

	const previousPage = () => {
		if (currentPage !== 1) {
			setCurrentPage(currentPage - 1);
		}
	};

	const nextPage = () => {
		if (currentPage !== Math.ceil(tpcCoursesLists.length / coursesPerPage)) {
			setCurrentPage(currentPage + 1);
		}
	};

    const [editCourse, setEditCourse] = useState(false);
   
    
    const toggleAddTpcCourseModal = () =>{
        setEditCourse(false)
        setModalAddTpcCourseModal(!modalAddTpcCourseModal);
        
    } 

    
    
    useEffect(() => {

        dispatch(fetchTpcCourses({}))

    },[props.createTpcCourse, props.updateTpcCourse, props.deleteTpcCourse, activeSpecialty])
    
    useEffect(() => {
        
        if(props.fetchTpcCourses.tpccourses.length){
            

            setTpcCoursesLists(props.fetchTpcCourses.tpccourses)
            setOrderedCourses(props.fetchTpcCourses.tpccourses)
        }
        else{
            setTpcCoursesLists([])
            setOrderedCourses([])
        }
        

    }, [props.fetchTpcCourses ])
    

    const handleEditDetails = (index) => {
        console.log(index)
        setModalAddTpcCourseModal(!modalAddTpcCourseModal);
        setEditCourse(index)
        
    }

    const handleDeleteDetails = (tpcCourseId) => {
        
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {

                dispatch(deleteTpcCourse({tpcCourseId : tpcCourseId}))
        
            }
        })

    }

    useEffect(() => {
    
        
        if(props.deleteTpcCourse.tpccourses.length && typeof props.deleteTpcCourse.error === "undefined"){
          
          Swal.fire({
              title: 'Success!',
              text: 'Successfully deleted TPC course!',
              icon : 'success',
              timer: 3000
              
            }
          ).then((result) => {
            dispatch(deleteTpcCourseReset());
            
          })
          
        }
      
        else if(typeof props.deleteTpcCourse.error !== "undefined"){
       
          Swal.fire({
              title:'Failed!',
              text:'Failed to delete TPC course!',
              icon :'error',
              timer: 3000
              
            }
          ).then((result) => {
            dispatch(deleteTpcCourseReset());
            
          })    
                
        }
      
    }, [props.deleteTpcCourse])

    const [editLesson, setEditLesson] = useState("")

    console.log(editLesson)

    const handleEditLesson = (e,courseData) => {
        e.preventDefault()
        setEditLesson(courseData)
        
    } 

    const handleBackToTpcCourses = (e) => {
        e.preventDefault()
        setEditLesson("")
    }

    const [searchCourse, setSearchCourse] = useState("");
    const [searchedCourse, setSearchedCourse] = useState([]);

    const searchCourses = async (value) => {
        let search = await arraySearch(tpcCoursesLists, value);
        setSearchedCourse(search);
        setSearchCourse(value);
    };
    const arraySearch = (array, keyword) => {
        console.log(array)
        const searchTerm = keyword.toLowerCase();
        return array.filter((value) => {
            return (
                value.courseDescription.toLowerCase().match(new RegExp(searchTerm, "g")) ||
                value.courseTitle.toLowerCase().match(new RegExp(searchTerm, "g")) ||
                value.instructorName.toLowerCase().match(new RegExp(searchTerm, "g"))
            );
        });
    };

    const [modalOrderCoursesModal, setModalOrderCoursesModal] = useState(false);

    const toggleOrderCoursesModal = () =>{
        setModalOrderCoursesModal(!modalOrderCoursesModal);
        
    } 


    const [orderedCourses, setOrderedCourses] = useState(tpcCoursesLists);

    // Function to move a course
    const moveCourse = (fromIndex, toIndex) => {
        setOrderedCourses((prev) => {
          const updatedCourses = [...prev];
          const [movedItem] = updatedCourses.splice(fromIndex, 1);
          updatedCourses.splice(toIndex, 0, movedItem);
      
          // Update the order field
          updatedCourses.forEach((course, idx) => (course.order = idx + 1));

          setTpcCoursesLists(updatedCourses)
          
          return updatedCourses;

          
        });
      };
      
      
    // Function to save the order
    const saveOrder = () => {
        const saveOrder = orderedCourses.map(item => ({courseTitle: item.courseTitle, tpcCourseId: item.tpcCourseId, order: item.order }));

        dispatch(saveCoursesOrder(saveOrder));

        Swal.showLoading()
        console.log("Saved Order:", saveOrder);
       
     
    };

   
    useEffect(() => {
        if(props.saveCoursesOrder.coursesorder.length && typeof props.saveCoursesOrder.error === "undefined"){
            
            Swal.fire({
                title: 'Success!',
                text: 'Successfully saved courses order!',
                icon : 'success',
                timer: 3000
                
                }
            ).then((result) => {
                dispatch(fetchTpcCourses({}))
                dispatch(saveCoursesOrderReset());
                
            })
            
        }
        
        else if(typeof props.saveCoursesOrder.error !== "undefined"){
            
            Swal.fire({
                title:'Failed!',
                text:'Failed to save courses order!',
                icon :'error',
                timer: 3000
                
                }
            ).then((result) => {
                dispatch(saveCoursesOrderReset());
                
            })    
                    
        }
    }, [props.saveCoursesOrder])

    return (
        <>
          <Header></Header>
        {
            editLesson ? 
            <>
              
                <Container className="mt--7" fluid>
                    <a href="" className="text-warning">
                    <Button className="shadow" color="info" onClick={(e) => handleBackToTpcCourses(e)}><i className="fas fa-arrow-left"></i>&nbsp;&nbsp;Back to Video Courses</Button></a>
                </Container> 
            </>
            
            : "" 
            
        }
        {
        Object.keys(editLesson).length === 0? <>
            <Container className="mt--7" fluid>
                <Row>
                    <Col>
                        <Card className="shadow">
                            <CardHeader>
                                <Row className="align-items-center">
                                    <Col md="6">
                                        <h3 className="mb-0">Video Courses</h3>
                                    </Col>
                                    <Col md="6" className="text-right">
                                        <Button title="Add Course" color="success" size="sm" className="mr-2" onClick={toggleAddTpcCourseModal}><i className="fas fa-plus" /> Add Course</Button>
                                        <Button title="Order Courses" color="success" size="sm" onClick={toggleOrderCoursesModal}><i className="fas fa-sort-numeric-down" /> Order Courses</Button>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Row className="mb-3">
                                    <Col lg="6" md="8" sm="12">
                                        <InputGroup>
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                    <i className="fas fa-search" />
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <Input
                                                placeholder="Search.."
                                                type="text"
                                                value={searchCourse}
                                                onChange={(e) => searchCourses(e.target.value)}
                                            />
                                        </InputGroup>
                                    </Col>
                                </Row>

                                {
                                    searchCourse ?
                                        searchedCourse.length ?
                                        <Row>
                                            {
                                                searchedCourse.map((c, i) => {
                                                    return (<Col xl="4" lg="4" md="6" sm="12" className="d-flex flex-column flex-wrap"><ManageCourseItem key={c.tpcCourseId} item={c} index={c.courseId} handleEditDetailsCallback={handleEditDetails} handlehandleEditCourseLessonsCallback={handleEditLesson} handleDeleteDetailsCallback={handleDeleteDetails} /></Col>)
                                                })
                                            }
                                            <Col xl="12" lg="12">
                                                {
                                                searchedCourse.length > coursesPerPage ?
                                                    <div className="d-flex justify-content-center mt-3">
                                                        <Paginate
                                                            itemPerPage={coursesPerPage}
                                                            totalItems={searchedCourse.length}
                                                            currentPage={currentPage}
                                                            paginate={paginate}
                                                            previousPage={previousPage}
                                                            nextPage={nextPage}
                                                        />
                                                    </div>
                                                : ""
                                                }
                                            </Col>
                                        </Row>
                                        : <p className='text-center font-weight-bolder text-dark'>No Result</p>
                                    :
                                    <>
                                        { !tpcCoursesLists.length ?
                                            <div className='text-center py-4'>
                                                <h2 className='mb-0'>No courses listed.</h2>
                                            </div>
                                            :
                                            <Row>
                                                {
                                                    currentCourses.map((c, i) => (
                                                        <Col xl="4" lg="4" md="6" sm="12" className="d-flex flex-column flex-wrap"><ManageCourseItem key={c.tpcCourseId} item={c} index={c.courseId} handleEditDetailsCallback={handleEditDetails} handlehandleEditCourseLessonsCallback={handleEditLesson} handleDeleteDetailsCallback={handleDeleteDetails}/></Col>
                                                    ))
                                                }
                                                <Col xl="12" lg="12">
                                                {
                                                    tpcCoursesLists.length > coursesPerPage ?
                                                    <div className="d-flex justify-content-center mt-3">
                                                        <Paginate
                                                            itemPerPage={coursesPerPage}
                                                            totalItems={tpcCoursesLists.length}
                                                            currentPage={currentPage}
                                                            paginate={paginate}
                                                            previousPage={previousPage}
                                                            nextPage={nextPage}
                                                        />
                                                    </div>
                                                    :""
                                                }
                                                </Col>
                                            </Row>
                                        }
                                    </>
                                }
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            </>
            : <Container className="mt-3" fluid><ManageTpcCoursesLessons courseData={editLesson}></ManageTpcCoursesLessons></Container>}
            <AddTpcCourseModal modalAddTpcCourseModal={modalAddTpcCourseModal} toggleAddTpcCourseModal={toggleAddTpcCourseModal} editCourse={editCourse} coursesData={props.fetchTpcCourses} />

            <Modal className="modal-dialog-centered" size="lg" isOpen={modalOrderCoursesModal}  toggle={toggleOrderCoursesModal}>
                    
                <ModalBody className='modal-body p-0'>
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent">
                            <Row className="align-items-center">
                            <Col xs="8">
                                <h3 className="mb-0">Order Courses</h3>
                            </Col>
                            <Col className="text-right" xs="4">
                                
                            </Col>
                            </Row>
                        </CardHeader>
                        <CardBody style={{maxHeight:"650px", overflowY: 'auto'}}>
                            <h6 className="heading-small text-muted mb-4">
                                Courses
                            </h6>
                         
                            <DndProvider backend={HTML5Backend}>
                                <div>
                                    
                                    {orderedCourses.map((course, index) => (
                                    
                                    <DraggableCourse
                                        key={course.tpcCourseId}
                                        course={course}
                                        index={index}
                                        moveCourse={moveCourse}
                                    />
                                    
                                    ))}
                                </div>
                            </DndProvider>
                                    
                        
                            
                        </CardBody>
                    </Card>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary"  onClick={toggleOrderCoursesModal}>
                        Cancel
                    </Button>
                    <Button color="primary" onClick={saveOrder}>
                            Save
                    </Button>
                </ModalFooter>
                
            </Modal>
        
        </>
    )
}

const mapStateToProps = state  => {
    return {
        userDetails : state.loginAuth.userDetails,
        fetchTpcCourses : state.fetchTpcCourses,
        createTpcCourse : state.createTpcCourse,
        updateTpcCourse : state.updateTpcCourse,
        deleteTpcCourse : state.deleteTpcCourse,
        fetchPaymentRecord: state.fetchPaymentRecord,
        saveCoursesOrder: state.saveCoursesOrder,
        activeSpecialty: state.specialty.activeSpecialty
    }

}

export default connect(mapStateToProps)(ManageTpcCourses)
